module.exports = __webpack_public_path__ + "img/bye-logo-no-shadow.39ca35b6.png";